export default __webpack_public_path__ + "static/media/Liver.f1750cae.png";